import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import {List, ListItem} from 'material-ui/List'

import { doc, dirtyRead } from 'selectors/common'

const colors = {
	forRent: "#BA68C8",
	outOfServ: "#000",
	occupied: "#39cea8",
	retired: "#A0A0A0"
}

let select = (state, props) => ({
	property: doc(state, props.id)
})


export class PropertyStatusIcon extends Component{
	render(){
		return(
			(!this.props.property)?
			<div></div>
			:
			<div style={{height: "100%", float: "left"}}>
				<svg
						width="30px"
						height="30px"
						viewBox="0 0 78 76"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlnsXlink="http://www.w3.org/1999/xlink"
						className="left-navigation-icons"
						style={{
							width: "35px "
						  , height: "20px "
						  , verticalAlign: "super"
						}}
					>
						<title>properties</title>
						<defs></defs>
						<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
							<g id="properties" fill={(this.props.property.status=='For Rent')?colors.forRent:
								(this.props.property.status=='Occupied')?colors.occupied:
								(this.props.property.status=='Retired')?colors.retired:
								(this.props.property.status=='Out Of Service'|| this.props.property.status=='Not In Service')?colors.outOfServ: "#A0A0A0"}>
								<path d="M77.249,34.53 L40.426,1.599 C40.362,1.542 40.292,1.498 40.223,1.451 C39.497,0.745 38.342,0.703 37.575,1.389 L0.751,34.321 C-0.05,35.037 -0.119,36.268 0.598,37.069 C0.982,37.499 1.515,37.718 2.049,37.718 C2.511,37.718 2.974,37.555 3.345,37.222 L10.356,30.952 L10.356,32.61 L10.356,49.802 L10.356,69.865 C10.356,72.754 12.706,75.104 15.595,75.104 C15.639,75.104 15.681,75.094 15.724,75.091 C15.768,75.094 15.809,75.104 15.853,75.104 L27.22,75.104 C29.79,75.104 31.881,73.11 32.085,70.592 C32.111,70.465 32.125,70.334 32.125,70.199 L32.125,50.679 C32.125,50.121 32.579,49.667 33.137,49.667 L44.864,49.667 C45.422,49.667 45.876,50.121 45.876,50.679 L45.876,70.199 C45.876,70.334 45.89,70.465 45.916,70.592 C46.12,73.11 48.211,75.104 50.781,75.104 L62.405,75.104 C65.343,75.104 67.644,72.19 67.644,68.471 L67.644,50.583 L67.644,45.103 L67.644,31.161 L74.655,37.431 C75.026,37.763 75.49,37.927 75.952,37.927 C76.486,37.927 77.019,37.708 77.403,37.278 C78.119,36.477 78.05,35.247 77.249,34.53 L77.249,34.53 Z M63.751,45.103 L63.751,50.583 L63.751,68.47 C63.751,70.17 62.879,71.211 62.404,71.211 L50.78,71.211 C50.222,71.211 49.768,70.757 49.768,70.199 L49.768,50.679 C49.768,47.975 47.568,45.775 44.864,45.775 L33.137,45.775 C30.433,45.775 28.233,47.975 28.233,50.679 L28.233,70.199 C28.233,70.757 27.779,71.211 27.221,71.211 L15.854,71.211 C15.81,71.211 15.768,71.221 15.725,71.224 C15.681,71.221 15.64,71.211 15.596,71.211 C14.853,71.211 14.249,70.607 14.249,69.864 L14.249,49.801 L14.249,32.609 L14.249,27.47 L38.883,5.44 L63.752,27.68 L63.752,45.103 L63.751,45.103 Z" id="Shape"></path>
							</g>
						</g>
					</svg>
			</div>
		)
	}
}
export default connect(select)(PropertyStatusIcon)



// WEBPACK FOOTER //
// ./src/routes/landlord/propertyForm/StatusIcon.js